<template>
    <main :class="{ 'main': true, 'with-sidebar': true, 'locked': showModal }">
        <div class="container">

            <div v-show="visible">

                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-header">
                            <span class="button-full" @click="toggleModal">{{ $t('button.add') }}</span>
                            <div class="page-header-controls">
                              <search></search>
                          </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <vuetable ref="services" :api-url="url"
                            :fields="columns"
                            :muti-sort="true"
                            :append-params="moreParams"
                            pagination-path="pagination"
                            @vuetable:pagination-data="onPaginationData"
                            @vuetable:load-success="onTableLoaded"
                        >
                        </vuetable>
                        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                    </div>
                </div>

                <service-modal :data="item" :show="showModal" :table="this.$refs.services"></service-modal>

            </div>

        </div>
    </main>
</template>
<script>
  import Vue from 'vue'
  import auth from '@/auth'
  import Vuetable from '@/components/vuetable/Vuetable'
  import VuetablePagination from '@/components/vuetable/VuetablePagination'
  import CustomActions from './CustomActions.vue'
  import inputWidget from '@/components/widgets/InputWidget.vue'
  import ServiceModal from './ServiceModal'
  import Search from './Search'
  import _ from 'lodash'

  Vue.component('custom-actions', CustomActions)

  export default {
    components: {
      Vuetable,
      VuetablePagination,
      inputWidget,
      ServiceModal,
      Search
    },
    name: 'Services',
    data () {
      return {
        visible: false,
        url: '/v1/services/',
        showModal: false,
        moreParams: {},
        currency: auth.getUser().personal.organization.currency,
        item: {
          name: null,
          duration: null,
          price: null,
          pause: null
        },
        columns: [
          {
            title: 'Id',
            name: 'id',
            sortField: 'id',
            visible: false
          },
          {
            title: this.$t('label.service'),
            name: 'name',
            sortField: 'name',
            titleClass: 'width-4'
          },
          {
            title: this.$t('label.duration'),
            name: 'duration',
            sortField: 'duration',
            callback: 'formatDuration',
            titleClass: 'width-3'
          },
          {
            title: this.$t('label.price'),
            name: 'price',
            sortField: 'price',
            callback: 'formatPrice',
            titleClass: 'width-3'
          },
          {
            name: '__component:custom-actions',
            title: '',
            titleClass: 'width-2',
            dataClass: 'table-controls'
          }
        ]
      }
    },
    mounted () {
      this.$events.$on('service-deleted', eventData => this.onDelete(eventData))
      this.$events.$on('service-edited', eventData => this.onEdit(eventData))
      this.$events.$on('service-search', eventData => this.onSearch(eventData))
      this.$events.$on('service-closed', eventData => this.onClosed(eventData))
    },
    methods: {
      transform: function (data) {
        // transform api data to fit our needs for pagination
        let transformed = {}

        transformed.pagination = {
          total: data.meta.total,
          per_page: data.meta.per_page,
          current_page: data.meta.current_page,
          last_page: data.meta.last_page,
          next_page_url: data.links.next,
          prev_page_url: data.links.prev,
          from: data.meta.from,
          to: data.meta.to
        }

        transformed.data = data.data
        return transformed
      },
      toggleModal () {
        this.item = {
          name: null,
          duration: 0.25,
          price: 0,
          pause: 0
        }
        this.showModal = !this.showModal
      },
      formatDuration (val) {
        let hour = parseInt(val)
        let minute = (val * 60) % 60
        return hour ? hour + this.$t('label.h') + (minute ? ' ' + minute + this.$t('label.min') : '') : minute + this.$t('label.min')
      },
      formatPrice (val) {
        return val + ' ' + this.currency.toUpperCase()
      },
      onEdit (item) {
        this.item = _.clone(item.rowData, true)
        this.showModal = true
      },
      onDelete () {
        Vue.nextTick(() => this.$refs.services.reload())
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.services.changePage(page)
      },
      onTableLoaded () {
        this.visible = true
      },
      onRowClicked (data, event, index) {
        this.item = data
      },
      onSearch (searchParams) {
        this.moreParams = searchParams
        Vue.nextTick(() => this.$refs.services.reload())
      },
      onClosed (data) {
        if (data.updated) {
          Vue.nextTick(() => this.$refs.services.reload())
        }
        this.showModal = data.show
      },
      clearData () {
        Object.assign(this.item, this.$options.data().item)
      },
      destroyed () {
        this.$events.off('service-search')
        this.$events.off('service-edited')
        this.$events.off('service-deleted')
        this.$events.off('service-closed')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Services/Services.vue